import {
  MemberEmailStatus,
  MemberInvitationStatus,
  MemberStatus,
} from '@tribeplatform/gql-client/types'
import { I18nShape } from '@tribeplatform/react-components/i18n'

export const getTranslatedMemberStatus = (
  { $t }: I18nShape,
  memberStatus: MemberStatus,
) => {
  switch (memberStatus) {
    case MemberStatus.Suspended:
      return $t({
        defaultMessage: 'Suspended',
        id: 'Generics.Suspended',
      })
    case MemberStatus.DELETED:
      return $t({
        defaultMessage: 'Deleted',
        id: 'Generics.Deleted',
      })
    case MemberStatus.UNVERIFIED:
      return $t({
        defaultMessage: 'Unverified',
        id: 'Generics.Unverified',
      })
    case MemberStatus.VERIFIED:
      return $t({
        defaultMessage: 'Verified',
        id: 'Generics.Verified',
      })
    default: {
      const exhaustiveCheck: never = memberStatus
      return exhaustiveCheck
    }
  }
}

export const getTranslatedEmailStatus = (
  { $t }: I18nShape,
  emailStatus: MemberEmailStatus,
) => {
  switch (emailStatus) {
    case MemberEmailStatus.verified:
      return $t({ defaultMessage: 'Verified', id: 'Generics.Verified' })
    case MemberEmailStatus.spammed:
      return $t({ defaultMessage: 'Spammed', id: 'Generics.Spammed' })
    case MemberEmailStatus.sent:
    case MemberEmailStatus.notDelivered:
      return $t({
        defaultMessage: 'Unverified',
        id: 'Generics.Unverified',
      })
    default: {
      const exhaustiveCheck: never = emailStatus
      return exhaustiveCheck
    }
  }
}

export const getTranslatedInvitationStatus = (
  { $t }: I18nShape,
  invitationStatus: MemberInvitationStatus,
) => {
  switch (invitationStatus) {
    case MemberInvitationStatus.Pending:
      return $t({ defaultMessage: 'Pending', id: 'Generics.Pending' })
    case MemberInvitationStatus.Expired:
      return $t({ defaultMessage: 'Expired', id: 'Generics.Expired' })
    case MemberInvitationStatus.Revoked:
      return $t({ defaultMessage: 'Revoked', id: 'Generics.Revoked' })
    case MemberInvitationStatus.accepted:
      return $t({ defaultMessage: 'Accepted', id: 'Generics.Accepted' })
    case MemberInvitationStatus.delivered:
      return $t({ defaultMessage: 'Delivered', id: 'Generics.Delivered' })
    case MemberInvitationStatus.notDelivered:
      return $t({
        defaultMessage: 'Not Delivered',
        id: 'Generics.NotDelivered',
      })
    case MemberInvitationStatus.notSent:
      return $t({ defaultMessage: 'Not Sent', id: 'Generics.NotSent' })
    case MemberInvitationStatus.rejected:
      return $t({ defaultMessage: 'Rejected', id: 'Generics.Rejected' })
    case MemberInvitationStatus.sent:
      return $t({ defaultMessage: 'Sent', id: 'Generics.Sent' })
    case MemberInvitationStatus.spammed:
      return $t({ defaultMessage: 'Spammed', id: 'Generics.Spammed' })
    default: {
      const exhaustiveCheck: never = invitationStatus
      return exhaustiveCheck
    }
  }
}
